import React from "react";
import Form from "../component/Form";

const Contact = () => {
  return (
    <div className="overflow-x-hidden bg-gray-50">
      <div className="container mx-auto px-4 py-12 ">
    <h1 className="text-4xl font-bold text-center mt-16 mb-10 text-[#78371b]">Get In Touch</h1>
        
        <div className="flex flex-col lg:flex-row bg-[#936856]  rounded-xl shadow-lg overflow-hidden">
          <div className="w-full lg:w-2/5 p-8  text-white">
            <h2 className="text-2xl font-bold mb-6">Contact Information</h2>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className=" p-3 rounded-full mr-4">
                  <img
                    src="../mail.png"
                    alt="Email Logo"
                    className="w-6 h-6"
                  />
                </div>
                <div>
                  <h6 className="font-bold text-lg">Email</h6>
                  <span className="text-blue-100">info@expertvisiontech.com</span>
                </div>
              </div>

              <div className="flex items-start">
                <div className=" p-3 rounded-full mr-4">
                  <img
                    src="../phone.png"
                    alt="Phone Logo"
                    className="w-6 h-6"
                  />
                </div>
                <div>
                  <h6 className="font-bold text-lg">Phone</h6>
                  <span className="text-blue-100">7309036214, 7309036216</span>
                </div>
              </div>

              <div className="flex items-start">
                <div className=" p-3 rounded-full mr-4">
                  <img
                    src="../location.png"
                    alt="Address Logo"
                    className="w-6 h-6"
                  />
                </div>
                <div>
                  <h6 className="font-bold text-lg">Address</h6>
                  <span className="text-blue-100">
                    Expertvision Technologies Private Limited<br />
                    Ground Floor, Devi Complex<br />
                    Near Sahbajganj Over Bridge<br />
                    Gida Sahjanwa, Gorakhpur<br />
                    Uttar Pradesh, India-273209
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="w-full lg:w-3/5 p-8">
            <h2 className="text-2xl font-bold mb-6 text-gray-800"></h2>
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;